import { resolveIAiGeneratedBrowserPublicServiceBaseUrl } from "@airange/shared/platform-urls";

function readEnv(key: string) {
  const value = typeof process !== "undefined" ? process.env?.[key] : undefined;
  return typeof value === "string" ? value.trim().replace(/\/+$/, "") : "";
}

function currentHostname() {
  return typeof window !== "undefined" ? window.location.hostname : undefined;
}

function resolveGeneratedPublicServiceUrl(service: "ctf-admin" | "ctf-portal", message: string) {
  try {
    return resolveIAiGeneratedBrowserPublicServiceBaseUrl(service, {
      readClientEnv: readEnv,
      hostname: currentHostname(),
    });
  } catch (error) {
    if (error instanceof Error && error.message.startsWith("Cannot resolve ")) {
      throw new Error(message);
    }
    throw error;
  }
}

export const CTF_API_BASE_URL = `${resolveGeneratedPublicServiceUrl(
  "ctf-admin",
  "CTF admin API base URL requires explicit env or a browser host that resolves the CTF admin service",
)}/api`;

export function resolveCtfApiEndpoint(path: `/api/${string}`) {
  return `${CTF_API_BASE_URL}${path.slice("/api".length)}`;
}

export const PORTAL_BASE_URL = resolveGeneratedPublicServiceUrl(
  "ctf-portal",
  "CTF admin portal base URL requires explicit env or a browser host that resolves the CTF portal service",
);
